import type {Step} from "../../components/stepper/Step.ts";
import {useAtomValue} from "jotai";
import {areCustomerOptionsSet, CustomerAnalysisOptionsAtom} from "../1-options/CustomerAnalysisOptions.ts";
import {CustomerWorkloadScanWidget} from "./CustomerWorkloadScanWidget.tsx";

export function useCustomerScanStep(): Step {
    const options = useAtomValue(CustomerAnalysisOptionsAtom)
    return {
        name: "Scanning",
        isCompleted: false,
        isAvailable: areCustomerOptionsSet(options),
        Widget: CustomerWorkloadScanWidget
    }
}